import React from 'react';
import { GetBrandedAppName } from '../../../services/BrandingService';
import VoicePicker from '../../VoicePicker';

export default class StoryPicker extends React.Component {
  constructor (props){
    super(props);
    this.state = {
      options: [],
      buttonsDisabled: true,
      loading: false,
    };

    this.selectStory = this.selectStory.bind(this);
  }

  componentDidMount(){
    document.title = `Select a Story - ${GetBrandedAppName()}`;

    this.readChoices();

    let options = this.props.recommendedStories.map((story)=>{
      let newStory = story;
      newStory.name = story.title;
      return newStory;
    });
    this.setState({
      options: options,
    });
  }

  readChoices(){
    let props = {};

    let onStart= (
      function(event){
        this.setState({
          buttonsDisabled: false,
        });
      }
    ).bind(this);

    this.props.speakChooseStoryMessage(this.props.speech, this.props.recommendedStories, null, onStart, true);
  }

  // returns a function to select a given story
  selectStory(story){
    if(this.props.speech){

      /*
      * Leave this in in case we decide to switch away from the GoModal for the tutor case.
      *   Delete if we decide definitively otherwise
      *
      //after aborting the spoken list of stories, verbally confirm the name of the selected story
      let props = {};

      props.textToSpeak = "Great! Let's read '" + story.title + "' together.";

      props.skipAvatar = false;

      //Send the proper sentence to the TTS object, listening afterwards
      function confirmStory(){this.props.speech.speak(props, true);}
      this.props.speech.abortSpeech(confirmStory.bind(this));
      **/
      this.props.speech.abortSpeech();
    }
    this.setState({
      loading: true,
    });
    this.props.setStory(story.storyid);
  }

  render() {
    return (
      <VoicePicker
        options={this.state.options}
        speech={this.props.speech}
        title={this.props.title}
        prompt="I'm sorry, I didn't understand that. Please say the title of the story you want to read."
        selectOption={this.selectStory}
        close={this.props.close}
        buttonsDisabled={this.state.buttonsDisabled}
        loading={this.state.loading}
      />
    );
  }
}
